<template>
  <v-dialog
    model-value
    persistent
    max-width="480px"
    class="dialog"
    @click:outside="onCancelClicked"
  >
    <div v-if="confirmation" class="relative py-4 px-4 md:px-0 w-full bg-grey-lighten-1">
      <div class="text-h6 text-grey-darken-2 mb-2">
        Are you sure?
      </div>
      <div>
        <div v-text="confirmation.message"></div>
        <div class="d-flex justify-end buttons">
          <v-btn
            class="mr-2 bg-grey-lighten-1"
            @click.stop="onCancelClicked"
          >No</v-btn>
          <v-btn
            class="mr-2"
            color="primary"
            @click.stop="onYesClicked"
          >Yes</v-btn>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapState } from 'vuex';

export default defineComponent({
  name: 'ConfirmationDialog',
  computed: mapState(['confirmation']),
  methods: {
    ...mapActions(['SET_CONFIRMATION_WAS_CONFIRMED']),
    onYesClicked() { this.SET_CONFIRMATION_WAS_CONFIRMED(true); },
    onCancelClicked() { this.SET_CONFIRMATION_WAS_CONFIRMED(false); },
  },
});
</script>

<style scoped>
.buttons {
  margin-top: 10px;
}
</style>
